export default __webpack_public_path__ + "static/media/EN_12.2e384e19.svg";